import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { PORTAL_ACCENT } from '../../styles/portalTheme';

const getInitials = (name) => {
  if (!name || typeof name !== 'string') {
    return '?';
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

/**
 * Inbox list row: generated title on top, actor name below.
 */
const NotificationActorRow = ({
  actorFullName,
  actorAvatarUrl,
  title,
  timeLabel,
  accentColor = PORTAL_ACCENT,
  isUnread = false,
}) => {
  const displayName = actorFullName?.trim();
  const displayTitle = title?.trim() || 'Notification';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        minWidth: 0,
        width: '100%',
      }}
    >
      <Box sx={{ position: 'relative', flexShrink: 0 }}>
        <Avatar
          src={actorAvatarUrl || undefined}
          alt={displayName || 'Notification'}
          sx={{
            width: 36,
            height: 36,
            bgcolor: `${accentColor}18`,
            color: accentColor,
            fontWeight: 700,
            fontSize: '0.7rem',
          }}
        >
          {actorAvatarUrl ? null : getInitials(displayName || displayTitle)}
        </Avatar>
        {isUnread ? (
          <Box
            sx={{
              position: 'absolute',
              top: -1,
              right: -1,
              width: 9,
              height: 9,
              borderRadius: '50%',
              bgcolor: accentColor,
              border: '2px solid',
              borderColor: 'background.paper',
            }}
          />
        ) : null}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 1,
            minWidth: 0,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              minWidth: 0,
              fontWeight: isUnread ? 700 : 600,
              fontSize: '0.875rem',
              lineHeight: 1.25,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'text.primary',
            }}
          >
            {displayTitle}
          </Typography>
          {timeLabel ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ flexShrink: 0, fontSize: '0.7rem', lineHeight: 1.25 }}
            >
              {timeLabel}
            </Typography>
          ) : null}
        </Box>

        {displayName ? (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 0.2,
              fontSize: '0.75rem',
              lineHeight: 1.25,
              color: 'text.secondary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {displayName}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default NotificationActorRow;
